<template>
    <div class="upformbox" :class="[wantdialog?'upformbox2':'']" v-model="upunm">
        <div class="up" @click="soleclick"></div> 
        <div class="cont">
            <div class="sole"  @click="soleclick"><i></i><i></i></div>
            <el-form :model="loginForm" :rules="loginFormRules" ref="ruleFormRef" label-width="" class="form">
                <div class="mk">
                    <div class="wli">
                        <div class="h">你需要做？</div>
                        <el-form-item label="">
                            <el-checkbox-group v-model="loginForm.whatdo">
                                <el-checkbox label="小程序" name="whatdo"></el-checkbox>
                                <el-checkbox label="APP" name="whatdo"></el-checkbox>
                                <el-checkbox label="网站" name="whatdo"></el-checkbox>
                                <el-checkbox label="WEB应用系统" name="whatdo"></el-checkbox>
                                <el-checkbox label="其它" name="whatdo"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </div>
                    <div class="wli">
                        <div class="h">希望它能帮助你实现什么？</div>
                        <el-form-item label="" prop="centent">
                            <el-input type="textarea" v-model="loginForm.centent" placeholder="在这里输入您的需求？"></el-input>
                        </el-form-item>
                    </div>
                    <div class="wli wli2">
                        <div class="h">个人的一些信息</div>
                        <el-form-item label="" prop="industry">
                            <el-input v-model="loginForm.industry" placeholder="输入您的行业"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="caller">
                            <el-input v-model="loginForm.caller" placeholder="输入您的称呼"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="phone">
                            <el-input v-model="loginForm.phone" placeholder="请填写11位手机号"></el-input>
                        </el-form-item>
                    </div>
                    <div class="sub">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <div class="ps">您也可以直接拨打电话18919819927（微信）来电咨询</div>
                    </div>
                </div>
            </el-form> 
        </div>
    </div>
</template>

<script>
    export default {
        props: ['upunm'],
        data() {
            // 定义表单数据和验证规则
            var validatePhoneNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                } else if (!/^1[3-9]\d{9}$/.test(value)) {
                    callback(new Error('请输入正确的手机号码'));
                } else {
                    callback();
                }
            };
            return {
                wantdialog:this.upunm,
                loginForm: {
                    whatdo: [],
                    centent: '',
                    industry: '',
                    caller: '',
                    phone: ''
                },
                loginFormRules: {
                    /* whatdo: [
                        { type: 'array', required: true, message: '请至少选择一项需求', trigger: 'change' }
                    ], */
                    centent: [
                        { required: true, message: '请输入您的需求', trigger: 'blur' }
                    ],
                    industry: [
                        { required: true, message: '请输入您的行业', trigger: 'blur' }
                    ],
                    caller: [
                        { required: true, message: '请输入您的称呼', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入您的11位手机号', trigger: 'blur' },
                        { validator: validatePhoneNumber }
                    ]
                }/* ,
                upunm: false */
            }
        },
        methods: {
            submitForm() {
                this.$refs.ruleFormRef.validate(async valid => {
                    if (valid) {
                        this.loginForm.whatdo = this.loginForm.whatdo.join(',')
                        const { data: res } = await this.$http.post('/api/demand', this.loginForm )
                        if( res.code == 200 ){
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            });
                            this.$refs.ruleFormRef.resetFields();
                            this.wantdialog = false
                            this.$emit('updateEvent', this.wantdialog);
                            // window.location.reload();
                        }
                        
                    } else {
                        
                        return false;
                    }
                });
            },
            soleclick(){
                this.wantdialog = false;
                this.$refs.ruleFormRef.resetFields();
                this.$emit('updateEvent', this.wantdialog);
            }
        },
        watch: {
            upunm(val) {
                this.wantdialog = val;//新增result的watch，监听变更并同步到myResult上
            }
        },
    }
</script>

<style>
    .upformbox{ position: fixed; top: 0; left: 0; z-index: -60; opacity: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;}
    .upformbox2{ opacity: 1; z-index: 60;}
    .upformbox .up{ position: absolute; top: 0; left: 0; background: #000; opacity: 0.8; z-index: 0; width: 100%; height: 100%;}
    .upformbox .cont{ width: 7rem; background: #fff; border-radius: 0.1rem; box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.13); position: relative; z-index: 5; transition: all 0.5s; transform: scale(0.2); opacity: 0;}
    .upformbox2 .cont{ opacity: 1; transform: scale(1);}
    .upformbox .form{ padding: 0.3rem;}
    .upformbox .form .wli + .wli{ margin-top: 0.35rem;}
    .upformbox .form .wli .h{ font-size: 0.18rem; line-height: 0.25rem; font-weight: bold; line-height: 1; margin-bottom: 0.15rem;}
    .upformbox .ps{ font-size: 0.16rem; color: #7B7B7B; text-align: center; line-height: 0.26rem; margin-top: 0.35rem;}
    .upformbox .sub{ margin-top: 0.35rem;}
    .upformbox .sub button{ transition: all 0.5s; display: block; width: 100%; height: 0.6rem; border-radius: 0.05rem; font-size: 0.2rem; background-color: #299DFB; color: #fff; cursor: pointer;}
    .upformbox .sub button:hover{ color: #2699FC; background: hsla(208,97%,57%,0.10); font-weight: bold; border-color: hsla(208,97%,57%,0.10);}
    .upformbox .wli2 el-form-item{ padding: 0.15rem 0; display: block;}
    /* .upformbox .form .wli2 .h{ margin-bottom: 0;} */
    .upformbox .el-input{ display: block;}
    .upformbox .el-input input{ height: 0.5rem; font-size: 0.16rem; border-radius: 0.05rem; border: 1px solid #E5E5E5; transition: all 0.5s;}
    .upformbox .el-input:hover input{ background: hsla(208,97%,57%,0.05); border-color: hsla(208,97%,57%,0.10);}
    .upformbox .wli .el-textarea{ display: block;}
    .upformbox .wli .el-textarea textarea{ font-size: 0.16rem; border-radius: 0.05rem; border: 1px solid #E5E5E5; transition: all 0.5s;}
    .upformbox .wli .el-textarea:hover textarea{ background: hsla(208,97%,57%,0.05); border-color: hsla(208,97%,57%,0.10);}
    .upformbox .el-checkbox-group{ display: flex; justify-content: space-between;}
    .upformbox .el-checkbox-group label{ transition: all 0.5s; cursor: pointer; line-height: 0.44rem; margin: 0; padding: 0 0.3rem; font-size: 0.18rem; border: 1px solid #DBDBDB; border-radius: 2px; color: #848484; position: relative;}
    .upformbox .el-checkbox-group label:hover{ background: hsla(208,97%,57%,0.05); border-color: hsla(208,97%,57%,0.10);}
    .upformbox .el-checkbox-group .el-checkbox__label{ font-size: 0.18rem; margin: 0; padding: 0;}
    .upformbox .el-checkbox-group .el-checkbox__input{ position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 2px; opacity: 0;}
    .upformbox .el-checkbox-group .el-checkbox__input .el-checkbox__inner,
    .upformbox .el-checkbox-group .el-checkbox__input input{ display: none;}
    /* .upformbox el-checkbox-group label.is-checked .el-checkbox__input{ background-color: #299DFB;} */
    .upformbox .el-checkbox-group label.is-checked{ border-color: #299DFB; color: #fff; background: #299DFB;}
    .upformbox .el-checkbox-group label.is-checked .el-checkbox__label{ color: #fff;}
    
    .el-message{ display: flex;}
    .el-message i{ font-size: 16px;}
    
    .upformbox .sole{ width: 0.24rem; height: 0.24rem; position: absolute; top: 0; right: -0.5rem; cursor: pointer; transition: all 0.5s;}
    .upformbox .sole i{ display: block; width: 100%; height: 2px; background: #fff; border-radius: 2px; position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%) rotate(45deg);}
    .upformbox .sole i:nth-child(2){ transform: translate(-50%,-50%) rotate(-45deg);}
    .upformbox .sole:hover{ transform: rotate(180deg);}
</style>